<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-card>
          <v-card-title
            class="mx-3 px-0 mb-3"
            style="border-bottom: 2px solid #d7531f"
          >
            <v-col cols="12" md="6">
              <v-icon style="margin-right: 20px; color: #00294b" size="50">
                mdi-swap-horizontal
              </v-icon>
              Transferências
            </v-col>
          </v-card-title>
          <v-card-text>
            <h3
              style="
                font-family: poppins;
                font-weight: 600;
                color: #686868 !important;
              "
            >
              Transferir agora
            </h3>
            <p style="margin-bottom: 10px !important; font-family: poppins">
              O acordo de transferência entre membros não é da responsabilidade
              da Ribus. Confirme o acordo antes de transferir os seus tokens.
            </p>
            
              <v-row>
                <v-col md="4" cols="12">
                  <v-text-field
                    v-model="transf.idDestinatario"
                    label="ID do destinatário"
                    color="#00294b"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="transf.qtdeRibus"
                    label="Qtde de Ribus"
                    color="#00294b"
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col md="5" cols="12" class="d-flex align-center">
                  <v-text-field
                    style="margin-bottom: 0px !important"
                    v-model="transf.authCode"
                    label="PIN Autenticação"
                    outlined
                    color="#00294b"
                  >
                  </v-text-field>
                  <v-btn
                    class="hoverbtn"
                    style="
                      background: radial-gradient(
                        circle,
                        rgba(255, 134, 41, 1) 0%,
                        rgba(0, 41, 75, 0) 46%
                      );
                      box-shadow: none;
                      background-color: transparent !important;
                    "
                    @click="transferir()"
                  >
                    Transferir</v-btn
                  >
                </v-col>
              </v-row>
            <h3
                style="
                  font-family: poppins;
                  font-weight: 600;
                  color: #686868 !important;
                  margin-top:20px;
                "
              >
                Extrato
              </h3>
            
              <v-data-table
                dense
                :headers="headers"
                :items="desserts"
                item-key="name"
              >
              </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.btnGerar.v-input__append-outer {
  background-color: #f0f0f0 !important;
  padding: 15px 22px !important;
  margin: 0px !important;
}

.hoverbtn:hover {
  background: radial-gradient(
    circle,
    rgba(255, 134, 41, 1) 0%,
    rgba(0, 41, 75, 0) 62%
  ) !important;
}
</style>

<script>
export default {
  name: "painelPerfil",
  data: () => ({
    transf: { 
        idDestinatario: null,
        qtdeRibus:null,
        authCode:null

    },
    message: "Hey!",
    desserts: [
      {
        data: "13/07/2022",
        cod: "62cee6e721f13",
        valor: "2.000,00 RIB",
        descri: "Transferência entre contas recebido de - QXN72628",
        status: "Entrada",
      },
      {
        data: "13/07/2022",
        cod: "62cee6e721f13",
        valor: "2.000,00 RIB",
        descri: "Transferência entre contas recebido de - QXN72628",
        status: "Entrada",
      },
    ],
    headers: [
      {
        text: "Data",
        align: "start",
        sortable: false,
        value: "data",
      },
      { text: "Cód. Transação", value: "cod" },
      { text: "Valor", value: "valor" },
      { text: "Descrição", value: "descri" },
      { text: "Status", value: "status" },
    ],
  }),
  methods: { 
    transferir() { 
        this.$http.post('users/transfer', { 
            value: this.transf.qtdeRibus,
            login: this.transf.idDestinatario
        }).then(res => { 
            if(res.data.status === "OK") { 
                this.$root.$emit("show-snack", {
                    type: `success`,
                    text: `Transferencia realizada com sucesso!.`,
                });     
                this.$store.dispatch("checkUser")     
            }
            this.transf = { 
                idDestinatario: null,
                qtdeRibus:null,
                authCode:null
            }
            // console.log(res)
        })
    }
  }
};
</script>
